/**
 * Возвращает типизированный объект из списка пар `[key, value]`
 *
 * @param entries Массив пар `[key, value]`
 * @returns Новый типизированный объект.
 */
export const fromEntries = <K extends string, V>(
  entries: readonly (readonly [K, V])[]
) => Object.fromEntries(entries) as Record<K, V>;
